import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Container } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Accordions from '../../Components/Accordion/AccordionRatingView'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from '../../Api/Api';
import { getStarColorClass } from '../../Functions/RatingLabelColor';
import InfoTooltip from '../../Components/InfoTooltip'
import ConfirmationPopup from '../../Components/ConfirmationPopup'
import StarRating from '../../Components/StarRating'
import ImagePopup from '../../Components/imagePreview'
import TextWithReadMore from '../../Components/Readmore'
import ShareLinkModal from "../../Components/ShareLinkModal";
import ConfirmPopupShareLink from '../../Components/ConfirmPopupShareLink'
import InfoTooltipRating from '../../Components/InfoTooltipRating'

import { IMAGE_PATHS, DOMAIN_URL, base64Encode,formatExperienceDate,getPerformanceRating } from '../../Functions/Constant';


const Acedmic = ({ scrollToReviews, academic, academicRatings ,user_id,showBuyAlert}) => {
    const [showModal, setShowModal] = useState(false);
    const [activityCount, setActivityCount] = useState(0);
    const [descriptionCount, setDescriptionCount] = useState(0);
    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const [languageProficiency, setLanguageProficiency] = useState("");
    const [suggestedLanguages, setSuggestedLanguages] = useState([]);
    const [locationsuggestions, setLocationSuggestions] = useState([]);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [file, setFile] = useState(null);
    const formikRef = useRef(null);
    const [suggestions, setSuggestions] = useState([]);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [education, setEducation] = useState([]);
    const [language, setLanguage] = useState([]);
    const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(false);
    const [degreeQuery, setDegreeQuery] = useState("");
    const [fieldQuery, setFieldQuery] = useState("");
    const [degreeSuggestions, setDegreeSuggestions] = useState([]);
    const [fieldSuggestions, setFieldSuggestions] = useState([]);
    const [showPopupC, setShowPopupC] = useState(false);
    const [showPopupCe, setShowPopupCe] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [showModalE, setShowModalE] = useState(false);
    const [educationData, setEducationData] = useState({
        school: "",
        degree: "",
        fieldOfStudy: "",
        startMonth: "",
        startYear: "",
        startYear: "",
        isCurrentlyWorking: false,
        endYear: "",
        location: "",
        grade: "",
        activities: "",
        description: "",
    });
    const [showOtherSchool, setShowOtherSchool] = useState(false);
    const [otherSchool, setOtherSchool] = useState("");
    const [languageQuery, setLanguageQuery] = useState("");
    const [languageSuggestions, setLanguageSuggestions] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditModeLm, setIsEditModeLm] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupL, setShowPopupL] = useState(false);
    const [selectedValueL, setSelectedValueL] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [locationquery, setLocationquery] = useState("");
    const [showFull, setShowFull] = useState(false);
    const [languageData, setLanguageData] = useState({

        language: "",
        otherLanguage: "",
        languageProficiency: "",
        proficiency: "",
        testName: "",
        totalScore: "",
        readingScore: "",
        listeningScore: "",
        writingScore: "",
        speakingScore: "",
        completion_year: "",
        completion_month: "",
        scoreCard: "",
        employee_language_id: ""
    });

    const handlePreview = (url) => {
        setImagePreview(`${DOMAIN_URL}/${url}`); // ✅ Correct URL
    };

    const [popupData, setPopupData] = useState({
        isOpen: false,
        title: "",
        message: "",
        onClose: () => { },
        onConfirm: () => { }
    });
    const [popupDataE, setPopupDataE] = useState({
        isOpen: false,
        message: "",
        onClose: () => { },
        onConfirm: () => { },
        linkToCopy: ""
    });

    useEffect(() => {
        if(!showBuyAlert){
            fetchEducation();
            fetchLanguage();
        }
        
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                setSuggestedLanguages([]);
                setDegreeSuggestions([]);
                setFieldSuggestions([]);
            }
        };
        //console.log("sxzvdsvdsvsdvsdvsd", academic);
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    const fetchEducation = async () => {
        const response = await API.get(`/education?user_id=${user_id}`);
        setEducation(response.education);
        console.log(response);
    };

    const fetchLanguage = async () => {
        const response = await API.get(`/language?user_id=${user_id}`);
        setLanguage(response.languages);
        console.log(response);
    };

    // Validation Schema
  


    const fetchSchool = async (search) => {
        if (!search) {
            setSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            console.log("📡 Calling API with query:", search);
            const response = await API.get(`/autocomplete/school?query=${search}`);
            const schoolList = Array.isArray(response) ? response : [];
            setSuggestions(schoolList); // Update state with extracted list
        } catch (error) {
            setSuggestions([]);
        } finally {
            setLoading(false);
        }
    };
    // Fetch Degree Suggestions
    const fetchDegrees = async (search) => {
        if (!search) {
            setDegreeSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/degrees?query=${search}`);
            setDegreeSuggestions(response);
        } catch (error) {
            setDegreeSuggestions([]);
        } finally {
            setLoading(false);
        }
    };

    // Fetch Field of Study Suggestions
    const fetchFieldsOfStudy = async (search) => {
        if (!search) {
            setFieldSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/fields_of_study?query=${search}`);
            setFieldSuggestions(response);
        } catch (error) {
            setFieldSuggestions([]);
        } finally {
            setLoading(false);
        }
    };
    
  

 
    const handleFileChange = (event, setFieldValue) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
            setFileSize(`${(selectedFile.size / 1024).toFixed(2)} KB`);
            setFieldValue("scoreCard", selectedFile);
            setFieldValue("score_card_url", ""); // Clear existing URL
            // Remove FileReader to prevent auto-preview
            // const reader = new FileReader();
            // reader.onload = (e) => setImagePreview(e.target.result);
            // reader.readAsDataURL(selectedFile);
        }
    };

    const handleRemoveFile = (setFieldValue) => {
        setFile(null);
        setFileName("");
        setFileSize("");
        setFieldValue("scoreCard", "");
        setFieldValue("score_card_url", "");
        setImagePreview(null);
        //setLanguageData({ ...languageData,scoreCard: "",  score_card_url: "" });
    };
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
  
    const [modalHeight, setModalHeight] = useState("auto");

    useEffect(() => {
        if (languageSuggestions.length > 0) {
            setModalHeight("350px");
        } else {
            setModalHeight("auto");
        }
    }, [languageSuggestions]);
   
    const [visibleEduSkills, setVisibleEduSkills] = useState(10);
    const loadMoreEduSkills = () => {
        setVisibleEduSkills((prev) => prev + 10);
    };
  
   
    const handleCreateLink = () => {
        setShowModalE(true);
    };
    
    const getGradeLabel = (value) => {
        // Empty input
        if (!value || value.trim() === '') {
            return '';
        }
    
        value = value.trim();
    
        // Check for GPA (only letters, optional + or -)
        if (/^[A-Za-z+\-]+$/.test(value)) {
            return 'GPA';
        }
    
        // Check for % with number (Percentage)
        if (value.includes('%') && /^-?\d*\.?\d*%?$/.test(value)) {
            return 'Percentage';
        }
    
        // Check for number or decimal (Percentage)
        if (/^-?\d*\.?\d*$/.test(value)) {
            return 'Percentage';
        }
    
        // Default case
        return '';
    };
    
    return (
        <>
            {
                academicRatings?.total_reviews > 0 && !showBuyAlert ? (<section className="pt-[20px] pb-[20px] px-4">

                    <Container >
                        <Row>
                            <Col xs={12} md={12}>
                                <div className="flex justify-between items-baseline">
                                    <div>
                                        <h3 className="text-[28px] font-bold text-black mb-1 leading-[1.5]">Academic Reviews</h3>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="rounded-lg p-6 pt-0 border-1 custm-bg shdo-box" >
                            <h3 className="text-[24px] font-bold mb-0 text-[#000]">Summary</h3>
                            <hr className="border-gray-300 mb-4 1" />
                            <Col lg={6} md={12} className="mb-6">
                                <div className="flex items-start space-x-3 mb-3">
                                    <div className="mt-[8px]">
                                        <span className="text-[40px] font-bold text-gray-900 lt">{academicRatings?.overall_rating.toFixed(1) ?? "0.0"}</span>
                                    </div>
                                    <div className="leading-[1.4]">
                                        <InfoTooltipRating className="text-[16px] font-bold text-gray-900" rating={academicRatings?.overall_rating} />
                                        <div className="flex items-center mb-2">
                                            {/* {[...Array(5)].map((_, index) => (
                                                <i
                                                    key={index}
                                                    className={`fas fa-star text-[16px] ${index < Math.round(academicRatings?.overall_rating ?? 0)
                                                        ? "yellow-i"
                                                        : "text-gray-300"
                                                        }`}
                                                ></i>
                                            ))} */}
                                            <StarRating rating={academicRatings?.overall_rating} starSize={15} />
                                            <span className="text-gray-600 text-[14px] ml-2 cursor-pointer hover:underline hover:text-black transition" onClick={scrollToReviews}>
                                                {academicRatings?.total_reviews ?? 0} Reviews
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-[#74787F] text-white text-[14px] px-3 py-0 rounded-[0.6rem] inline-block shdo-box sm:leading-[1.5]">
                                    This summary is created by AI, based on recent reviews.
                                </div>
                                <p className="text-gray-700 text-[14px] mt-3 leading-[1.5]">
                                    <TextWithReadMore text={academic?.ai_summary} />
                                </p>

                                {/* Key Strengths */}
                                {academic.key_strengths != null && Array.isArray(academic.key_strengths) && academic.key_strengths.length > 0 ? (
                                    <div className="mt-2">
                                        <h4 className="font-bold text-gray-900 text-[16px] mb-2">Key Strengths</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {
                                                academic.key_strengths.map((skill, index) => (
                                                    <span key={index} className="flex items-center px-2 py-0 text-sm font-medium text-black rounded-full gap-2 h-m bg-white">
                                                        <i className={`fas fa-star ${getStarColorClass(skill.rating)}`}></i>
                                                        <span className="black-class"> {skill.name} </span>
                                                        <span className="text-gray-500"> ({skill.total})</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                                {/* Improvement Areas */}
                                {academic?.improvement_areas && Array.isArray(academic.improvement_areas) && academic.improvement_areas.length > 0 ? (
                                    <div className="mt-2">
                                        <h4 className="font-bold text-gray-900 text-[16px] mb-2">Improvement Areas</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {
                                                academic.improvement_areas.map((weakness, index) => (
                                                    <span key={index} className="flex items-center px-2 py-0 font-medium text-black text-sm rounded-full gap-2 h-m bg-white">
                                                        <i className={`fas fa-star ${getStarColorClass(weakness.rating)}`}></i>
                                                        <span className="black-class"> {weakness.name} </span>
                                                        <span className="text-gray-500"> ({weakness.total})</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </Col>

                            <Col lg={6} md={12} className="">
                                <Accordions data={Array.isArray(academic?.category_ratings) ? academic.category_ratings : []} />
                            </Col>
                        </Row>
                    </Container>
                </section>) : (<></>)
            }
            {
                !showBuyAlert && (<>
                <section className={` px-4 ${education.length === 0 ? "pb-0" : "pb-0"}`}>
                <Container>
                    {/* Experience Header */}
                    <Row>
                        <Col xs={12} md={12} className={`${education.length === 0 ? "p-0" : ""}`}>
                            <div className={`flex justify-between items-baseline ${education.length === 0 ? "bg-white rounded-lg p-6 border border-gray-200  shadow-lg" : ""}`}>
                                <div>
                                    <h3 className={`text-[22px] font-bold text-gray-900 mb-2 leading-[1.4] ${education.length === 0 ? "mt-1" : "mt-3"}`}>Education <InfoTooltip text="Add education details to get feedback from school friends and teachers." /></h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {
                        education.map((educationVal, index) => (
                            <Row className="bg-white rounded-lg p-6 border-1 mb-[20px] !pr-[14px] ">
                                <Col lg={1} md={2} sm={2} xs={2}>
                                    <img
                                        src={IMAGE_PATHS.SCHOOL}
                                        className="w-[60px] h-[60px] bg-gray-300 rounded-md sm:w-[auto] sm:h-[auto]"
                                    />
                                </Col>
                                <Col lg={10} md={9} sm={9} xs={8} className="leading-[1.4]">
                                    <h4 className="text-lg font-bold text-gray-900 mb-0 ">{educationVal.school_name.length > 50 ? `${educationVal.school_name.substring(0, 50)}... ` : educationVal.school_name}</h4>
                                    {/* <p className="text-gray-700">{educationVal.degree_name}</p> */}
                                    <p className="text-gray-700 overflow-hidden">
                                        <span className="font-bold text-gray-600"> {educationVal.degree_name.length > 50 ? `${educationVal.degree_name.substring(0, 50)}... ` : educationVal.degree_name}
                                        </span><span className="ml-1 font-bold text-gray-600"> | {educationVal.field_name}</span></p>
                                    <p className="text-gray-700 ">
                                        {formatExperienceDate(educationVal.start_month, educationVal.start_year, educationVal.end_month, educationVal.end_year)}
                                    </p>
                                    <p className="text-gray-700">{educationVal.location}</p>
                                    {
                                        getGradeLabel(educationVal?.grade) !== '' && (
                                            <p className="text-gray-700">
                                                {getGradeLabel(educationVal.grade)}: {educationVal.grade}
                                            </p>
                                        )
                                    }

                                    <p className="text-gray-700 mt-2">
                                        <TextWithReadMore text={educationVal.activities} />
                                    </p>

                                </Col>

                               
                                {educationVal.overall_rating != null && educationVal.overall_rating.total_reviews > 0 ? (<>
                                    <hr className="border-gray-300 my-4 border-t-1" />
                                    <Col lg={2} md={12} className="text-start">
                                        <div className="text-[40px] font-bold leading-[1.2] text-[#000] lt">{educationVal.overall_rating.overall_rating}</div>
                                        <InfoTooltipRating className="font-medium text-[18px] text-[#000]" rating={educationVal.overall_rating.overall_rating} />
                                        <div className="flex  mt-0">

                                            <StarRating rating={educationVal.overall_rating.overall_rating} starSize={15} />
                                        </div>
                                        <p className="text-gray-500 text-sm cursor-pointer hover:underline hover:text-black transition" onClick={scrollToReviews}>{educationVal.overall_rating.total_reviews} Reviews</p>
                                    </Col>

                                    {/* Rating Breakdown */}
                                    <Col lg={4} md={12} sm={12} className="border-r border-gray-300 sm:border-r-0 md:border-r-0">
                                        <div className="space-y-1">
                                            {[
                                                { label: 5, value: parseInt(educationVal.overall_rating.excellent) },
                                                { label: 4, value: parseInt(educationVal.overall_rating.very_good) },
                                                { label: 3, value: parseInt(educationVal.overall_rating.average) },
                                                { label: 2, value: parseInt(educationVal.overall_rating.poor) },
                                                { label: 1, value: parseInt(educationVal.overall_rating.terrible) },
                                            ].map((item, index) => (
                                                <div key={index} className="flex items-center justify-between space-x-2">
                                                    {/* Label */}
                                                    <span className="text-gray-900 text-sm font-medium w-[80px]"  >{getPerformanceRating(item.label).level}</span>

                                                    {/* Progress Bar */}
                                                    <div className="flex-1 h-[12px] bg-gray-200 rounded-full overflow-hidden mx-2">
                                                        <div
                                                            className="h-full yellow-b rounded-full"
                                                            style={{
                                                                width: `${educationVal.overall_rating.total_reviews > 0
                                                                    ? (item.value / educationVal.overall_rating.total_reviews) * 100
                                                                    : 0
                                                                    }%`,
                                                            }}
                                                        ></div>
                                                    </div>

                                                    {/* Count */}
                                                    <span className="text-gray-900 text-sm font-medium sm:w-[18px] w-[40px] text-start pl-[8px]">
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col lg={6} md={12} sm={12} className="pl-[45px] rpl sm:pt-[20px] md:pt-[20px] md:pl-[17px]">
                                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 gap-y-2 gap-x-4">
                                            {educationVal.categories.map((item, index) => (
                                                <div key={index} className="flex flex-col justify-center items-start leading-[1]">
                                                    <div className="leading-[1.4] flex items-center h-[20px]">
                                                        <span className="font-medium text-[14px] text-[#000]">{item.name}</span>
                                                    </div>
                                                    <div className="flex items-center w-full">
                                                        <div className="w-[78%] h-[12px] bg-gray-200 rounded-full overflow-hidden mr-2 sm:w-[94%] xs:w-[92%] md:w-[92%]">
                                                            <div className="h-full yellow-b" style={{ width: `${(item.avg_rating / 5) * 100}%` }}></div>
                                                        </div>
                                                        <div className="dd">
                                                            <span className="text-[#000] text-[14px] ">{item.avg_rating.toFixed(1)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>


                                    {/* Tags Section */}
                                    <Row className="mt-4">
                                        <Col lg={12}>
                                            <div className="flex flex-wrap gap-2 mt-2">
                                                {
                                                    educationVal.skills.slice(0, visibleEduSkills).map((skill, index) => {
                                                        let starColor = getStarColorClass(skill.avg_rating);
                                                        return (
                                                            <span
                                                                key={index}
                                                                className="flex items-center px-2 py-0 font-medium text-black text-sm rounded-full gap-2 h-m bg-white"
                                                            >
                                                                <i className={`fas fa-star mr-1 ${starColor}`}></i>
                                                                <span className="black-class">{skill.name}</span>
                                                                <span className="text-gray-500">({skill.total_ratings})</span>
                                                            </span>
                                                        );
                                                    })
                                                }
                                               {
                                                    educationVal.skills.length > 10 && (
                                                        <button
                                                            onClick={() => {
                                                                if (visibleEduSkills < educationVal.skills.length) {
                                                                    setVisibleEduSkills((prev) => prev + 10); // View More
                                                                } else {
                                                                    setVisibleEduSkills(10); // View Less
                                                                }
                                                            }}
                                                            className="text-black font-medium ml-2 cursor-pointer hover:underline"
                                                        >
                                                            {visibleEduSkills < educationVal.skills.length ? "View More" : "View Less"}
                                                        </button>
                                                    )
                                                }
                                            </div>


                                        </Col>
                                    </Row>

                                    {/* CTA Button */}
                                   
                                </>) : (<>
                        
                                </>)
                                }
                            </Row>
                        ))
                    }

                </Container>
            </section>
            <section className="py-3 px-4 !pt-[20px] !pb-[40px]">
                <Container>
                    <Row>
                        <Col xs={12}  className={`${language.length === 0 ? "p-0" : ""}`}>
                            <div className={`flex justify-between items-baseline  ${language.length === 0 ? "bg-white rounded-lg p-6 border border-gray-200  shadow-lg" : ""}`}>
                                <div>
                                    <h3 className={`text-[22px] font-bold text-gray-900 mb-2 leading-[1.4]  ${language.length === 0 ? "mt-1" : "mt-3"}`}>Language <InfoTooltip text="Add your proficiency and upload certifications for a stronger profile." /></h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {
                        language.map((languageVal, index) => (

                            languageVal.has_certificate === 0 ? (
                                <Row className="bg-white rounded-lg p-6 border mb-4 !pr-[14px]">
                                    <Col lg={10} sm={6} xs={6} className="mb-2">
                                        <h4 className="text-lg font-bold text-gray-900 mb-0">{languageVal.language_name}</h4>
                                        <p className="text-gray-500 text-sm font-semibold flex items-center">
                                            <span className="mr-2">{languageVal.level_name}</span>
                                        </p>
                                    </Col>
                                  
                                </Row>
                            ) : (
                                <Row className="bg-white rounded-lg p-6 border mb-4 !pr-[14px]">
                                    <Col lg={10}  sm={6} xs={8} className="mb-2">
                                        <h4 className="text-lg font-bold text-gray-900 mb-0">{languageVal.language_name}</h4>
                                        <p className="font-bold text-gray-900 text-sm">{languageVal.test_name}</p>
                                        <p className="text-gray-500 text-sm font-semibold flex items-center">
                                            <span className="mr-2">{months[languageVal.completion_month]} {languageVal.completion_year}</span>
                                            <span className="px-2 py-[2px] text-xs font-medium bg-black text-white rounded-full flex items-center">
                                                <i className="fas fa-check-circle yellow-class mr-1"></i>
                                                Certified
                                            </span>
                                        </p>
                                    </Col>
                                  
                                    <hr className="border-gray-300 w-full my-3" />

                                    <Col lg={2}  className="text-start sm:mb-[8px]">
                                        <div className="box-total">
                                            <h4 className="text-lg font-bold yellow-class mb-0 text-center">Total</h4>
                                            <h1 className="text-[40px] font-bold yellow-class leading-[1] mb-0">{Math.round(languageVal.total_score)}</h1>
                                        </div>

                                    </Col>
                                    <Col lg={9}  sm={11} xs={11} className="flex flex-col justify-center ">
                                        <div className="grid grid-cols-2 md:grid-cols-1 gap-y-2 gap-x-4 ">
                                            {[
                                                { label: "Reading", score: Math.round(languageVal.reading_score) },
                                                { label: "Writing", score: Math.round(languageVal.writing_score) },
                                                { label: "Listening", score: Math.round(languageVal.listening_score) },
                                                { label: "Speaking", score: Math.round(languageVal.speaking_score) },
                                            ].map((item, index) => (
                                                <div key={index} className="flex items-center justify-between ">
                                                    {/* Label */}
                                                    <span className="text-gray-900 text-sm font-medium w-[25%]">{item.label}</span>

                                                    {/* Progress Bar */}
                                                    <div className="w-[75%] h-[12px] bg-gray-200 rounded-full overflow-hidden">
                                                        <div className="h-full yellow-b rounded-full" style={{ width: `${item.score}%` }}></div>
                                                    </div>

                                                    {/* Score Value */}
                                                    <span className="text-gray-900 text-sm font-medium w-[15%] text-center ">{item.score}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col lg={1} sm={1} xs={1} className="text-end flex items-start justify-end pr-[3px] ">
                                        <a onClick={() => handlePreview(languageVal.score_card_url)}>
                                            <i className="fas fa-file-pdf font-bold text-[15px] text-black cursor-pointer"></i>
                                        </a>
                                    </Col>
                                    {imagePreview && <ImagePopup imageUrl={imagePreview} onClose={() => setImagePreview(null)} />}

                                </Row>)


                        ))
                    }

                </Container>
            </section>
                </>)
            }
            
        </>
    );
};

export default Acedmic;
